import React, { useState } from "react";
import { FaDownload, FaFilePdf, FaFileWord, FaSearch, FaFilter } from "react-icons/fa";
import NursingGuidelines from "../assets/doc/Brief Introduction to Lesotho Nurses Association-2.pdf";
import CommunityHealthGuide from "../assets/doc/Final Submitted Report_State of Nursing and Midwfery Workforce in Lesotho 2022 (1).pdf";
import LeadershipToolkit from "../assets/doc/plan.pdf";
import Membership from "../assets/doc/Membership application form.docx";
import Grievance from "../assets/doc/Grievence form.docx";
import heroImage from "../assets/res.jpg";

const Resources = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("all");

  const resourceList = [
    {
      title: "Brief Introduction to Lesotho Nurses Association",
      description: "Comprehensive guidelines on best practices for patient care, including nursing protocols, clinical standards, and emergency procedures.",
      link: NursingGuidelines,
      type: "PDF",
      category: "guidelines",
      date: "2024-01-15"
    },
    {
      title: "The State of Nursing and Midwifery Workforce in Lesotho - 2022",
      description: "Nurses and midwives are the backbone of the health care system in Lesotho and are found at all levels of care. The Lesotho Nurses Association (LNA) acknowledges that having well-educated, equitably distributed, and motivated nurses and midwives is critical to improving the health of the population and achieving Universal Health Coverage.",
      link: CommunityHealthGuide,
      type: "PDF",
      category: "report",
      date: "2022-12-01"
    },
    {
      title: "National Nursing and Midwifery Strategic Plan 2021/22 – 2026/27",
      description: "“United Nurses and Midwives Shall Never Fall” — It is my singular honour and pleasure to present the National Nursing and Midwifery Strategic Plan (NNMSP) for the period 2021/22 to 2026/27. This strategy defines the direction that the National Nursing and Midwifery (NNM) will take in pursuit of excellence in the nursing and midwifery sectors of Lesotho.",
      link: LeadershipToolkit,
      type: "PDF",
      category: "strategic-plan",
      date: "2021-03-20"
    },
    {
      title: "Membership Application Form",
      description: "Download the membership form to complete your details and signature. Once completed, please proceed with payment via:\n\n" +
        "1. **M-Pesa** - LS NURSES ASSOCIATION **45799**\n" +
        "2. **EcoCash** - Dial *100# and send payment to **+266 XXXXXXXX**\n" +
        "3. **Standard Lesotho Bank** - **9080002004379** (Maseru City Branch)\n\n" +
        "Attach proof of payment with your submission.",
      link: Membership,
      type: "DOCX",
      category: "forms",
      date: "2024-02-01"
    },
    {
      title: "Public Sector Grievance Form",
      description: "The Grievance Form is an official document used by public officers to lodge formal complaints regarding workplace issues. It is structured into three main parts:\n\n" +
        "Part A – Public Officer’s Details & Nature of Grievance:\n" +
        "The public officer provides personal and employment details, ministry/department, the grievance date, and detailed explanation.\n\n" +
        "Part B – Enquiry and Resolution:\n" +
        "Captures the date of the enquiry and the proposed solution. It requires signatures from the enquiry chairperson, the supervisor, the officer, their representative, and HR.\n\n" +
        "Part C – Appeal Process:\n" +
        "Allows for appeal if the officer is unsatisfied. Includes appeal details, solution, and required signatures. If unresolved, the issue may be referred to the Conciliation Board within 5 working days.",
      link: Grievance,
      type: "DOCX",
      category: "forms",
      date: "2024-02-01"
    },
  ];

  const filteredResources = resourceList.filter(resource => {
    const matchesSearch = resource.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         resource.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = filterType === "all" || resource.type.toLowerCase() === filterType.toLowerCase();
    return matchesSearch && matchesFilter;
  });

  const getFileIcon = (type) => {
    return type === "PDF" ? <FaFilePdf style={{ color: "#e74c3c" }} /> : <FaFileWord style={{ color: "#2b579a" }} />;
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div style={styles.container}>
      {/* Hero Section */}
      <header style={styles.heroSection}>
        <div style={styles.heroOverlay}>
          <div style={styles.heroContent}>
            <h1 style={styles.heroTitle}>Professional Resources</h1>
            <p style={styles.heroSubtitle}>
              Access essential documents, guidelines, and forms for Lesotho nursing professionals
            </p>
          </div>
        </div>
        <img src={heroImage} alt="Nursing Professionals at Work" style={styles.heroImage} />
      </header>

      {/* Main Content */}
      <main style={styles.mainContent}>
        <section style={styles.section}>
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>Resource Library</h2>
            <p style={styles.sectionDescription}>
              Browse our collection of official documents, reports, and forms essential for nursing professionals in Lesotho.
            </p>
          </div>

          {/* Search and Filter Section */}
          <div style={styles.controls}>
            <div style={styles.searchBox}>
              <FaSearch style={styles.searchIcon} />
              <input
                type="text"
                placeholder="Search resources..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={styles.searchInput}
              />
            </div>
            <div style={styles.filterGroup}>
              <FaFilter style={styles.filterIcon} />
              <select
                value={filterType}
                onChange={(e) => setFilterType(e.target.value)}
                style={styles.filterSelect}
              >
                <option value="all">All File Types</option>
                <option value="pdf">PDF Documents</option>
                <option value="docx">Word Documents</option>
              </select>
            </div>
          </div>

          {/* Resources Grid */}
          <div style={styles.resultsInfo}>
            <p>Showing {filteredResources.length} of {resourceList.length} resources</p>
          </div>

          <div style={styles.cardGrid}>
            {filteredResources.map((resource, index) => (
              <div key={index} style={styles.card}>
                <div style={styles.cardHeader}>
                  <div style={styles.fileType}>
                    {getFileIcon(resource.type)}
                    <span style={styles.fileTypeText}>{resource.type}</span>
                  </div>
                  <div style={styles.cardDate}>{formatDate(resource.date)}</div>
                </div>
                
                <h3 style={styles.cardTitle}>{resource.title}</h3>
                <p style={styles.cardDescription}>{resource.description}</p>
                
                <div style={styles.cardFooter}>
                  <a
                    href={resource.link}
                    download
                    style={styles.downloadButton}
                    aria-label={`Download ${resource.title}`}
                  >
                    <FaDownload style={{ marginRight: "8px" }} />
                    Download Document
                  </a>
                </div>
              </div>
            ))}
          </div>

          {filteredResources.length === 0 && (
            <div style={styles.noResults}>
              <p>No resources found matching your criteria. Please try different search terms or filters.</p>
            </div>
          )}
        </section>
      </main>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    backgroundColor: "#f8fafc",
    minHeight: "100vh",
  },
  heroSection: {
    position: "relative",
    height: "400px",
    overflow: "hidden",
  },
  heroImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  heroOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 51, 102, 0.85)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroContent: {
    textAlign: "center",
    color: "white",
    maxWidth: "800px",
    padding: "2rem",
  },
  heroTitle: {
    fontSize: "clamp(2.5rem, 5vw, 4rem)",
    fontWeight: "700",
    marginBottom: "1rem",
    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
  },
  heroSubtitle: {
    fontSize: "1.3rem",
    fontWeight: "300",
    opacity: 0.9,
    lineHeight: 1.6,
  },
  mainContent: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "3rem 2rem",
  },
  section: {
    marginBottom: "3rem",
  },
  sectionHeader: {
    textAlign: "center",
    marginBottom: "3rem",
  },
  sectionTitle: {
    fontSize: "2.5rem",
    color: "#003366",
    fontWeight: "600",
    marginBottom: "1rem",
  },
  sectionDescription: {
    fontSize: "1.1rem",
    color: "#666",
    maxWidth: "600px",
    margin: "0 auto",
    lineHeight: 1.6,
  },
  controls: {
    display: "flex",
    gap: "1.5rem",
    marginBottom: "2rem",
    flexWrap: "wrap",
    alignItems: "center",
  },
  searchBox: {
    position: "relative",
    flex: "1",
    minWidth: "300px",
  },
  searchIcon: {
    position: "absolute",
    left: "1rem",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#666",
  },
  searchInput: {
    width: "100%",
    padding: "0.75rem 1rem 0.75rem 3rem",
    border: "1px solid #ddd",
    borderRadius: "8px",
    fontSize: "1rem",
    backgroundColor: "white",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  filterGroup: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  filterIcon: {
    color: "#666",
  },
  filterSelect: {
    padding: "0.75rem 1rem",
    border: "1px solid #ddd",
    borderRadius: "8px",
    fontSize: "1rem",
    backgroundColor: "white",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    minWidth: "180px",
  },
  resultsInfo: {
    marginBottom: "1.5rem",
    color: "#666",
    fontSize: "0.95rem",
  },
  cardGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(380px, 1fr))",
    gap: "2rem",
  },
  card: {
    backgroundColor: "white",
    borderRadius: "12px",
    padding: "2rem",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.1)",
    border: "1px solid #e2e8f0",
    transition: "all 0.3s ease",
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "1.5rem",
  },
  fileType: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    fontSize: "0.9rem",
    fontWeight: "600",
  },
  fileTypeText: {
    color: "#666",
  },
  cardDate: {
    fontSize: "0.85rem",
    color: "#888",
  },
  cardTitle: {
    fontSize: "1.4rem",
    color: "#003366",
    fontWeight: "600",
    marginBottom: "1rem",
    lineHeight: 1.4,
  },
  cardDescription: {
    fontSize: "1rem",
    color: "#555",
    lineHeight: 1.6,
    flex: 1,
    marginBottom: "1.5rem",
    whiteSpace: "pre-wrap",
  },
  cardFooter: {
    marginTop: "auto",
  },
  downloadButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    backgroundColor: "#0073e6",
    color: "white",
    padding: "0.75rem 1.5rem",
    borderRadius: "6px",
    fontWeight: "600",
    fontSize: "0.95rem",
    transition: "all 0.3s ease",
    width: "100%",
    textAlign: "center",
  },
  noResults: {
    textAlign: "center",
    padding: "3rem",
    color: "#666",
    fontSize: "1.1rem",
  },
};

// Add hover effects
const hoverStyles = `
  .resource-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }
  
  .download-button:hover {
    background-color: #005bb5;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 115, 230, 0.3);
  }
`;

// Inject hover styles
const styleSheet = document.styleSheets[0];
if (styleSheet) {
  const hoverStyleElement = document.createElement('style');
  hoverStyleElement.textContent = hoverStyles;
  document.head.appendChild(hoverStyleElement);
}

export default Resources;